
import useAuthToken from './useAuthToken';
import useAuthIsAccountActivated from './useAuthIsAccountActivated';

const useAuthNeedActivation = () => {

    const token = useAuthToken();
    const activated = useAuthIsAccountActivated();

    const needActivation = token && !activated;

    return needActivation;
}

export default useAuthNeedActivation;
